import { render, staticRenderFns } from "./SurveyAnswerForm.vue?vue&type=template&id=565c8bb6"
import script from "./SurveyAnswerForm.vue?vue&type=script&lang=js"
export * from "./SurveyAnswerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports